import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContex } from '../context API/UserContext';

const AddUser = () => {
    const [firstName,setFirstName]=useState("")
    const [lastName, setLastName] = useState("");
    const [email,setEmail]=useState("")
    const [password,setPassword]=useState("")
     const [userData, setUserData] = useContext(UserContex);
    const navigate=useNavigate()
     const handlesubmit=(e)=>{
        e.preventDefault()
        axios 
          .post("https://back.waratechnology.com/api/user/uregister", {
            firstName,
            lastName,
            email,
            password,
          })
          .then((res) => {
            console.log(res.data.msg);
            navigate("/profile");
          })
          .catch((err) => {
            console.log(err);
          })};
          useEffect(() => {
            if (!userData.user) {
              navigate("/login");
            }
          });
  return (
    <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
      <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
        <div className="flex justify-center mt-2 mb-4">
          <h1 className="uppercase font-bold text-2xl">Add User</h1>
        </div>
        <form onSubmit={handlesubmit} className="grid grid-cols-1 gap-4">
          <div className="flex ">
            <input
              placeholder="first name"
              type="text"
              className="w-full py-2  pl-2 h-12 md:h-8 mb-4 border border-gray-300 rounded-2xl"
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="flex">
            <input
              placeholder="last name"
              type="text-"
              className="w-full py-2 h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="flex">

            <input
              placeholder="email"
              type="email"
              className="w-full py-2 h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="flex">
            <input
              placeholder="password"
              type="password"
              className="w-full py-2 h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="flex justify-center mt-4">
            <button
              type=""
              className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-fully"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddUser
